import { render, staticRenderFns } from "./FourthTab.vue?vue&type=template&id=1c604e10&scoped=true"
import script from "./FourthTab.vue?vue&type=script&lang=js"
export * from "./FourthTab.vue?vue&type=script&lang=js"
import style0 from "./FourthTab.vue?vue&type=style&index=0&id=1c604e10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c604e10",
  null
  
)

export default component.exports